// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__9H3QU","add_icon_row":"styles_add_icon_row__Xl49q","add_icon_column":"styles_add_icon_column__LUhdp"};